import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { useParentNavAlwaysEnabled } from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import { useAbility } from 'utilities/ability'
import AccordionButton from '../Bar/AccordionButton'
import MenuItem from '../Bar/MenuItem'
import LoyaltyContent from './Content'

const t = buildTranslate('nav.loyalty_menu')

type PropsT = {
  isLeftNav?: boolean
  onClick?: () => void
  paths: string[]
}

const Loyalty: React.FC<PropsT> = ({
  isLeftNav = false,
  onClick = () => {},
  paths,
}) => {
  const ability = useAbility()
  const merchant = useCurrentMerchant()

  const parentAlwaysEnabled = useParentNavAlwaysEnabled()

  const exclusiveDealsDisabled =
    ability.cannot('manage', 'ExclusiveDeals') || !merchant?.exclusive_deals

  const menuDisabled =
    !parentAlwaysEnabled &&
    ability.cannot('manage', 'LegacyReports') &&
    ability.cannot('access', 'Points') &&
    ability.cannot('access', 'Tiers') &&
    exclusiveDealsDisabled

  const Parent = isLeftNav ? AccordionButton : MenuItem
  return (
    <Parent disabled={menuDisabled} paths={paths} buttonContents={t('button')}>
      <LoyaltyContent isLeftNav={isLeftNav} onClick={onClick} />
    </Parent>
  )
}

export default Loyalty
